import {
  AdType,
  SetAdTypeOnPageLoadType,
  SetWithSearchHeroAction,
} from './layout';

export function setWithSearchHero(
  withSearchHero: boolean,
): SetWithSearchHeroAction {
  return {
    type: 'SET_WITH_SEARCH_HERO',
    payload: {
      withSearchHero,
    },
  };
}

export function setAdTypeOnPageLoad(adType: AdType): SetAdTypeOnPageLoadType {
  return {
    type: 'SET_AD_TYPE_ON_PAGE_LOAD',
    payload: {
      adType,
    },
  };
}
